(() => {
  const getCopy = () => {
    const isSpanish = (document.documentElement.lang || '').toLowerCase().startsWith('es');
    return isSpanish
      ? {
          title: 'Tu carrito no reserva stock',
          body: 'Completa el pago para asegurar disponibilidad.',
          saving: 'Ahora mismo ahorras'
        }
      : {
          title: 'Items aren’t reserved until checkout',
          body: 'Complete checkout to secure availability.',
          saving: 'You’re saving'
        };
  };

  const ensureUrgency = (drawer) => {
    if (!drawer) return;

    const trust = drawer.querySelector('.wizzy-cart__trust');
    if (!trust) return;

    const hasCartItem = Boolean(drawer.querySelector('.cart-item'));
    let urgency = drawer.querySelector('.wizzy-cart__urgency');

    if (!hasCartItem) {
      urgency?.remove();
      return;
    }

    if (!urgency) {
      urgency = document.createElement('div');
      urgency.className = 'wizzy-cart__urgency';
      urgency.setAttribute('role', 'status');
      urgency.innerHTML = `
        <span class="wizzy-cart__urgency-dot" aria-hidden="true"></span>
        <div>
          <strong class="wizzy-cart__urgency-title"></strong>
          <span class="wizzy-cart__urgency-copy"></span>
        </div>
      `;
      trust.insertAdjacentElement('afterend', urgency);
    }

    const copy = getCopy();
    const savings = drawer.querySelector('.wizzy-cart__savings-total strong')?.textContent?.trim();
    const title = urgency.querySelector('.wizzy-cart__urgency-title');
    const body = urgency.querySelector('.wizzy-cart__urgency-copy');
    const bodyText = savings ? `${copy.saving} ${savings}. ${copy.body}` : copy.body;

    if (title && title.textContent !== copy.title) title.textContent = copy.title;
    if (body && body.textContent !== bodyText) body.textContent = bodyText;
  };

  const mountDrawerAtViewport = () => {
    const sectionDrawer = document.querySelector('#shopify-section-cart-drawer cart-drawer');
    const drawers = document.querySelectorAll('cart-drawer');
    const drawer = sectionDrawer || drawers[drawers.length - 1];
    if (!drawer) return;

    document.querySelectorAll('body > cart-drawer[data-wizzy-root="true"]').forEach((oldDrawer) => {
      if (oldDrawer !== drawer) oldDrawer.remove();
    });

    drawer.dataset.wizzyRoot = 'true';

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    ensureUrgency(drawer);

    if (!drawer.__wizzyUrgencyObserver) {
      drawer.__wizzyUrgencyObserver = new MutationObserver(() => ensureUrgency(drawer));
      drawer.__wizzyUrgencyObserver.observe(drawer, { childList: true, subtree: true });
    }
  };

  const start = () => {
    mountDrawerAtViewport();

    const rootObserver = new MutationObserver(() => {
      const sectionDrawer = document.querySelector('#shopify-section-cart-drawer cart-drawer');
      const bodyDrawer = document.querySelector('body > cart-drawer[data-wizzy-root="true"]');
      if (sectionDrawer || !bodyDrawer) mountDrawerAtViewport();
    });

    rootObserver.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', () => requestAnimationFrame(mountDrawerAtViewport));
})();
